module.exports = __webpack_public_path__ + "img/register.ab9853c9.svg";